import {useTranslation} from "react-i18next";
import {getEntries, includesSome, isNotEmptyNorFalsy} from "../../../utilities/helperFunctions";
import {applicationFeatures} from "../../../utilities/constants";
import {AddButtonHeader} from "../../common/Button/Button";
import UserServiceRow from "../UserServiceRow";
import UserServiceModel from "../../../models/user/UserServiceModel";
import {useDispatch, useSelector} from "react-redux";
import React from "react";
import {TableLabelHeader} from "../../common/CustomTable/CustomTable";

const OidcUserServiceTable = () => {
    const {t} = useTranslation(['aria', 'userService', 'common']);
    const dispatch = useDispatch();

    const canAddUserService = useSelector(state => includesSome(state.currentUser.features, [applicationFeatures.ADD_RESOURCE, applicationFeatures.MODIFY_USER_SERVICES]));
    const oidcUserServiceIds = getEntries(useSelector(state => state.userServiceDetailsMap))
        .filter(([,userService]) => userService.type === UserServiceModel.types.OIDC)
        .map(([id]) => id);

    function showOidcUserServiceForm() {
        dispatch(UserServiceModel.actionCreators.showForm({type: UserServiceModel.types.OIDC}));
    }

    const isNotEmpty = isNotEmptyNorFalsy(oidcUserServiceIds);
    if (!canAddUserService && !isNotEmpty) {
        return null;
    }

    return (
        <div className="display-item">
            <AddButtonHeader aria-label={t('aria:hiddenAssistText.addOidcUserService')} text={t('userService:label.oidcUserServiceTitle')}
                canModify={canAddUserService} onClick={showOidcUserServiceForm}
            />

            {isNotEmpty &&
                <div className="display-table">
                    <div className="table-header-group">
                        <div className="table-header"/>
                        <TableLabelHeader label={t('common:label.name')} style={{width: '20rem'}}/>
                    </div>

                    <div className="table-row-group">
                        {oidcUserServiceIds.map(id =>
                            <UserServiceRow key={id} type={UserServiceModel.types.OIDC} userServiceId={id}/>
                        )}
                    </div>
                </div>
            }
        </div>
    );
};

export default OidcUserServiceTable;
